import { createSlice } from "@reduxjs/toolkit";

const dashBoardSlice = createSlice({
  name: "dashboard",
  initialState: {
    data: null,
  },
  reducers: {
    setDashboardData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setDashboardData } = dashBoardSlice.actions;
export const selectDashboardData = (state) => state.dashboard.data;

export default dashBoardSlice.reducer;
